/**
 * Internal page links support optional anchors: /slug#section-{componentId}
 */

const SECTION_FRAGMENT = /^section-(.+)$/;

export function buildPageSectionHref(pathPart: string, componentId?: string | null): string {
  const base =
    pathPart === '' || pathPart === '/'
      ? '/'
      : pathPart.startsWith('/')
        ? pathPart
        : `/${pathPart}`;
  if (!componentId) return base === '' ? '/' : base;
  return `${base === '' ? '/' : base}#section-${componentId}`;
}

export function splitPageSectionHref(value: string): {
  basePath: string;
  sectionComponentId: string | null;
} {
  const hashIdx = value.indexOf('#');
  if (hashIdx === -1) {
    return { basePath: value, sectionComponentId: null };
  }
  let basePath = value.slice(0, hashIdx);
  if (basePath === '') basePath = '/';
  const fragment = value.slice(hashIdx + 1);
  const m = SECTION_FRAGMENT.exec(fragment);
  return {
    basePath,
    sectionComponentId: m ? m[1] : null,
  };
}
